import { installationConfig } from "./installation-config";

export const privacyPolicy = installationConfig.privacyPolicy;
export const termsConditions = installationConfig.termsConditions;
export const peopleLanding = installationConfig.landing;
export const telegramSupport = installationConfig.telegramSupport;
export const mailSupport = installationConfig.mailSupport;
